import Vue from 'vue';
import couponScopeComponent from './coupon-scope';

const CouponScope = Vue.extend(couponScopeComponent);

let instance;

export default {
  show(options = {}) {
    if (!instance) {
      instance = new CouponScope({
        el: document.createElement('div'),
        data() {
          return {
            title: options.title,
            desc: options.desc,
            position: options.position,
            show: true,
          };
        },
      });
      return document.body.appendChild(instance.$el);
    }
    instance._data.title = options.title;
    instance._data.desc = options.desc;
    instance._data.position = options.position;
    instance._data.show = true;
  },
  hide() {
    instance._data.show = false;
  },
};



// WEBPACK FOOTER //
// ./src/components/coupon/coupon-scope/index.js